import script from "./SelectorBase.vue?vue&type=script&setup=true&lang=ts"
export * from "./SelectorBase.vue?vue&type=script&setup=true&lang=ts"

import "./SelectorBase.vue?vue&type=style&index=0&id=6a2995cc&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a2995cc"]])

export default __exports__